import Reveal from '@/components/base/Reveal';
import SectionHeading from '@/components/feature/SectionHeading';
import { networkPartners } from '@/mocks/homeData';

const marqueeItems = [...networkPartners, ...networkPartners];

export default function NetworkSection() {
  return (
    <section id="network" className="relative w-full bg-background-50 py-14 md:py-20 overflow-hidden">
      <div className="pointer-events-none absolute -top-20 right-0 w-80 h-80 rounded-full bg-secondary-100/60 blur-3xl"></div>

      <div className="relative w-full px-4 md:px-8">
        <SectionHeading
          eyebrow="Our Network"
          title="Trusted Distribution Network"
          description="Building strong partnerships with distributors, retailers, healthcare professionals and wellness businesses across India."
        />

        <Reveal>
          <div className="relative mt-10 md:mt-14">
            <div className="flex w-max animate-marquee-slow hover:[animation-play-state:paused]">
              {marqueeItems.map((item, index) => (
                <div
                  key={`${item.id}-${index}`}
                  className="mx-2.5 flex items-center gap-3 rounded-full border border-secondary-200 bg-background-50 px-6 py-3 transition-colors hover:border-primary-300"
                >
                  <span className="w-9 h-9 flex items-center justify-center rounded-full bg-secondary-100 text-secondary-700 shrink-0">
                    <i className="ri-building-2-line"></i>
                  </span>
                  <span className="font-semibold text-foreground-700 text-sm whitespace-nowrap">{item.label}</span>
                </div>
              ))}
            </div>

            <div className="pointer-events-none absolute left-0 top-0 bottom-0 w-16 md:w-28 bg-gradient-to-r from-background-50 to-transparent"></div>
            <div className="pointer-events-none absolute right-0 top-0 bottom-0 w-16 md:w-28 bg-gradient-to-l from-background-50 to-transparent"></div>
          </div>
        </Reveal>

        <Reveal delay={120}>
          <div className="mt-10 grid grid-cols-1 sm:grid-cols-3 gap-5">
            <div className="rounded-lg border border-background-200 bg-background-100/70 p-5">
              <span className="w-10 h-10 flex items-center justify-center rounded-full bg-primary-100 text-primary-700">
                <i className="ri-group-line text-lg"></i>
              </span>
              <h3 className="font-heading mt-4 text-base font-semibold text-foreground-950">300+ Active Partners</h3>
              <p className="mt-1.5 text-sm text-foreground-600">
                A growing family of stockists, dealers and pharmacy chains across South India.
              </p>
            </div>
            <div className="rounded-lg border border-background-200 bg-background-100/70 p-5">
              <span className="w-10 h-10 flex items-center justify-center rounded-full bg-accent-100 text-accent-700">
                <i className="ri-truck-line text-lg"></i>
              </span>
              <h3 className="font-heading mt-4 text-base font-semibold text-foreground-950">Pan-India Delivery</h3>
              <p className="mt-1.5 text-sm text-foreground-600">
                Reliable dispatch and supply support for bulk and third-party manufacturing orders.
              </p>
            </div>
            <div className="rounded-lg border border-background-200 bg-background-100/70 p-5">
              <span className="w-10 h-10 flex items-center justify-center rounded-full bg-secondary-100 text-secondary-700">
                <i className="ri-hand-heart-line text-lg"></i>
              </span>
              <h3 className="font-heading mt-4 text-base font-semibold text-foreground-950">Partner Support</h3>
              <p className="mt-1.5 text-sm text-foreground-600">
                Dedicated assistance for retailers, clinics and healthcare businesses we serve.
              </p>
            </div>
          </div>
        </Reveal>
      </div>
    </section>
  );
}